<div class="alert">
    <img src="../../../../assets/icons/timeout.svg" alt="">
    <h1 mat-dialog-title class="title">
        {{'ALERT_SESSION.expired'|translate}}
    </h1>
    <p>
        {{'ALERT_SESSION.sign_in'|translate}}
    </p>
</div>